import {Component, input, ChangeDetectionStrategy} from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { MatIconModule } from "@angular/material/icon";

@Component({
    imports: [CommonModule, MatCardModule, MatIconModule],
    selector: "loren-parameter-card",
    styleUrls: ["./loren-parameter-card.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "./loren-parameter-card.component.html"
})
export class LorenParameterCardComponent {
  svgIcon = input.required<string>();
  name = input.required<string>();
  value = input.required<string | number>();
}
